import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { App } from '@/App.tsx'
import { initServiceWorker } from '@/serviceWorker'
import '@/index.scss'
import { AuthenticationResult, EventMessage, EventType } from '@azure/msal-browser'
import { msalInstance } from './modules/Auth'

initServiceWorker().then(() => {
    msalInstance.initialize().then(() => {
        const accounts = msalInstance.getAllAccounts()
        if (accounts.length > 0) {
            msalInstance.setActiveAccount(accounts[0])
        }

        msalInstance.addEventCallback((event: EventMessage) => {
            if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
                const payload = event.payload as AuthenticationResult
                const account = payload.account
                msalInstance.setActiveAccount(account)
            }
        })

        createRoot(document.getElementById('root')!).render(
            <StrictMode>
                <App pca={msalInstance} />
            </StrictMode>
        )
    })
})
